import { useState, FunctionComponent } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

// components
import { Link } from 'dibs-elements/exports/Link';
import Contact1stdibsModalLazy from './Contact1stdibsModalLazy';

// helpers
import { trackFooterNavigationClick } from '../../helpers/trackingHelpers';

import styles from '../Footer/LinkColumn/LinkColumnItem.scss';

type Props = {
    trackingLabel: string;
};

const Contact1stdibsFooterLink: FunctionComponent<Props> = ({ trackingLabel }) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    return (
        <li className={styles.item}>
            <Link
                className={styles.contact1stdibsLink}
                dataTn="footer-contact-1stdibs"
                onClick={() => {
                    setIsContactModalOpen(true);
                    trackFooterNavigationClick({ label: trackingLabel });
                }}
            >
                <FormattedMessage
                    id="dbl.Footer.site_links_contact_1stdibs"
                    defaultMessage="Contact 1stDibs"
                />
            </Link>
            <Contact1stdibsModalLazy
                isOpen={isContactModalOpen}
                placement="globalFooter"
                onClose={() => setIsContactModalOpen(false)}
            />
        </li>
    );
};

export default Contact1stdibsFooterLink;
